import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import RankingSection from './components/RankingSection';
import { Link } from 'react-router-dom';
import { featuredAnime } from '@/mocks/anime';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '羞羞动漫网站',
    url: 'https://www.xiuxiudongman.com/',
    description: '羞羞动漫网站提供动漫美女爆羞羞动漫在线蜜桃等国产精品动漫内容，免费在线看蜜桃动漫大全。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.xiuxiudongman.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '羞羞动漫网站',
    url: 'https://www.xiuxiudongman.com/',
    description: '专注于国产精品动漫内容的在线观看平台，提供蜜桃动漫、精品动漫推荐与动漫美女角色等内容。',
    sameAs: [
      'https://www.xiuxiudongman.com/',
    ],
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '羞羞动漫网站提供哪些类型的动漫内容？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '羞羞动漫网站提供蜜桃动漫、国产精品动漫、动漫美女角色、恋爱甜宠、奇幻冒险、热血战斗、搞笑日常、悬疑推理等多种类型的动漫内容，全部免费在线观看。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在羞羞动漫网站上找到51动漫国产精品入口？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '访问羞羞动漫网站首页即可看到51动漫国产精品入口专区，也可以通过分类导航中的「国产精品」栏目进入，浏览斗破苍穹、仙王的日常生活等热门国产动漫作品。',
        },
      },
      {
        '@type': 'Question',
        name: '羞羞动漫网站是否需要注册或付费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '羞羞动漫网站完全免费，无需注册即可在线观看所有动漫内容。我们致力于为广大动漫爱好者提供优质的免费动漫资源。',
        },
      },
      {
        '@type': 'Question',
        name: '蜜桃动漫专区有什么特色内容？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '蜜桃动漫专区是羞羞动漫网站的特色栏目，汇集了蜜桃成熟时、蜜桃少女的秘密花园等精选作品，以恋爱、校园、青春题材为主，画风精美，剧情甜蜜动人。',
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <LatestSection />
        <RankingSection />

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
                为什么选择羞羞动漫？
              </h2>
              <p className="text-sm text-foreground-500">51动漫国产精品入口，品质保证</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
              <div className="p-5 bg-white rounded-lg border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-50">
                  <i className="ri-movie-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">海量资源</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">汇集上千部国产精品动漫，每日更新不断</p>
              </div>
              <div className="p-5 bg-white rounded-lg border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-accent-50">
                  <i className="ri-shield-check-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">高清画质</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">全高清画质，流畅播放体验</p>
              </div>
              <div className="p-5 bg-white rounded-lg border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-secondary-50">
                  <i className="ri-women-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">美女角色</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">精选动漫美女角色，精美画风呈现</p>
              </div>
              <div className="p-5 bg-white rounded-lg border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-50">
                  <i className="ri-heart-pulse-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">完全免费</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">无需注册付费，随时随地免费观看</p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
                热门标签
              </h2>
              <p className="text-sm text-foreground-500">发现你感兴趣的动漫话题</p>
            </div>
            <div className="flex flex-wrap justify-center gap-2">
              {['蜜桃动漫', '国产精品', '动漫美女', '恋爱甜宠', '校园青春', '奇幻冒险', '热血战斗', '魔法少女', '搞笑日常', '甜宠恋爱', '动漫推荐', '在线观看'].map((tag) => (
                <Link
                  key={tag}
                  to={`/category/${tag === '蜜桃动漫' ? 'mitao' : tag === '国产精品' ? 'guochan' : tag === '动漫美女' ? 'meinv' : tag === '恋爱甜宠' ? 'lianai' : tag === '奇幻冒险' ? 'qihuan' : tag === '热血战斗' ? 'rexue' : tag === '搞笑日常' ? 'gaoxiao' : 'guochan'}`}
                  className="px-4 py-1.5 bg-white border border-background-200/70 rounded-full text-xs text-foreground-600 hover:text-primary-500 hover:border-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-6">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
                精彩专题
              </h2>
              <p className="text-sm text-foreground-500">精选合集，一次看个够</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-5">
              <Link to="/category/mitao" className="group relative rounded-lg overflow-hidden h-48 cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Romantic%20anime%20style%20illustration%20with%20cherry%20blossoms%20and%20warm%20pink%20tones%2C%20soft%20dreamy%20atmosphere%2C%20anime%20couple%20silhouette%2C%20spring%20theme%2C%20beautiful%20scenery&width=800&height=400&seq=special-mitao&orientation=landscape"
                  alt="蜜桃动漫专题"
                  title="蜜桃动漫专题合集"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-black/20"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-white font-heading text-lg mb-1">蜜桃动漫合集</h3>
                  <p className="text-white/80 text-xs">甜蜜恋爱，青春校园精选</p>
                </div>
              </Link>
              <Link to="/category/guochan" className="group relative rounded-lg overflow-hidden h-48 cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Epic%20Chinese%20donghua%20style%20illustration%20with%20martial%20arts%20and%20fantasy%20elements%2C%20dramatic%20golden%20lighting%2C%20ancient%20Chinese%20architecture%2C%20majestic%20atmosphere&width=800&height=400&seq=special-guoc&orientation=landscape"
                  alt="国产精品动漫专题"
                  title="国产精品动漫专题合集"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-black/20"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-white font-heading text-lg mb-1">国产精品合集</h3>
                  <p className="text-white/80 text-xs">热血玄幻，顶级制作水准</p>
                </div>
              </Link>
              <Link to="/category/meinv" className="group relative rounded-lg overflow-hidden h-48 cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Beautiful%20anime%20girls%20collection%20illustration%2C%20magical%20girl%20theme%2C%20sparkling%20stars%20and%20ribbons%2C%20soft%20pastel%20colors%2C%20elegant%20and%20cute%20style%2C%20dreamy%20atmosphere&width=800&height=400&seq=special-meinv&orientation=landscape"
                  alt="动漫美女角色专题"
                  title="动漫美女角色专题合集"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-black/20"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-white font-heading text-lg mb-1">美女角色合集</h3>
                  <p className="text-white/80 text-xs">魔法少女，精美角色呈现</p>
                </div>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}